import "zone.js";
import {NgModule, DoBootstrap, Inject, ElementRef, TemplateRef} from '@angular/core';
import { BrowserModule} from '@angular/platform-browser';
import { UpgradeModule} from '@angular/upgrade/static';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import { PeopleModule } from './features/people/people.module';
import { EventsModule } from './features/events/events.module';
import { CommonModule } from './features/common/common.module';
import { SharedModule } from './shared/shared.module';
import { AuthModule } from './features/auth/auth.module';
import { CoreModule } from './core/core.module';
import { LogService } from './core/services/log.service';
import { $stateParamsProvider, $stateProvider, datasetsServiceProvider, eventServiceProvider, generateDocumentServiceProvider, loginServiceProvider, notificationServiceProvider } from './ajs-upgraded-providers';
import { HttpClient, provideHttpClient, withInterceptors, withInterceptorsFromDi } from "@angular/common/http";
import { PrimeNG, providePrimeNG } from "primeng/config";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import lara_default from '../../node_modules/@primeng/themes/lara/index.mjs';
import {TranslateLoader, TranslateModule, TranslateService} from '@ngx-translate/core';
import { es }  from "primelocale/js/es.js";
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Table, TableService } from "primeng/table";
import { languageInterceptor } from "./angularjs/interceptors/language.interceptor";
import { ConfirmationService, MessageService } from 'primeng/api';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './api/lang/i18n/', '/json');
}
@NgModule({
    imports: [
        BrowserModule,
        UpgradeModule,
        PeopleModule,
        EventsModule,
        SharedModule,
        CommonModule,
        AuthModule,
        CoreModule,
        TranslateModule.forRoot({
            defaultLanguage: 'es',
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    providers: [
        $stateParamsProvider,
        datasetsServiceProvider,
        $stateProvider,
        loginServiceProvider,
        notificationServiceProvider,
        generateDocumentServiceProvider,
        eventServiceProvider,
        provideHttpClient(withInterceptorsFromDi(), withInterceptors([languageInterceptor])),
        provideAnimationsAsync(),
        providePrimeNG({
            theme: {
                preset: lara_default,
                options: {
                    darkModeSelector: 'body.dark'
                }   
            }
        }),
        Table,
        TableService,
        MessageService,
        ConfirmationService
       ]
})
export class AppModule implements DoBootstrap {
    constructor(@Inject(UpgradeModule) private upgrade: UpgradeModule,
                @Inject(LogService) private log: LogService,
                @Inject(PrimeNG) private primeng: PrimeNG,
                @Inject(TranslateService) private translateService: TranslateService) { }

    // Override Angular bootstrap so it doesn't do anything
    ngDoBootstrap() {
        console.log('Bootstrapping Hybrid AngularJS/Angular Application');
//        this.log.debug("Bootstrapping in Hybrid mode with Angular & AngularJS");
        this.translateService.setDefaultLang('es');
        this.primeng.setTranslation(es);
        this.primeng.zIndex = {
            modal: 1100,    // dialog, sidebar
            overlay: 1200,  // dropdown, overlaypanel
            menu: 1200,     // overlay menus
            tooltip: 1300   // tooltip
        };
        this.upgrade.bootstrap(document.body, ['app'], { strictDi: true });
    }

    translate(lang: string) {
        this.translateService.use(lang);
        this.translateService.get('primeng').subscribe(res => this.primeng.setTranslation(res));
    }
}

platformBrowserDynamic().bootstrapModule(AppModule);